<template>
  <div>
    <div v-show="series.length > 0" class="pa-1 bordered rounded bg-grey_3" :id="'containerPerDay_' + id_module"></div>
  </div>
</template>

<script>
import { useMainStore } from "@/stores/mainStore";
import { mapStores } from "pinia";
import Highcharts from "highcharts";
import AdminService from "@/services/admin.service";
export default {
  props: ['id_module'],
  data() {
    return {
      per_day: {},
      represented_course: [],
      categories: [],
      series: [],
    };
  },
  watch: {
    id_module: {
      handler: function () {
        if (!this.id_module) return;
        this.loadData();
      },
      immediate: true,
    },
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    async loadData() {
      let res = await AdminService.getStatistiquesInscriptions(this.id_module);
      this.build_data(res);
    },

    build_data(data) {
      if (!data) return;
      this.per_week = {};
      this.represented_course = [];
      const first_inscription_timestamp = this.$moment(data[0].timestamp);
      const last_inscription_timestamp = this.$moment(data[data.length - 1].timestamp);
      let start = this.$moment(first_inscription_timestamp).endOf("week");
      let end = this.$moment(last_inscription_timestamp).endOf("week");
      while (start.isBefore(end)) {
        if (!this.per_week[start.format("DD/MM/YYYY")]) {
          this.per_week[start.format("DD/MM/YYYY")] = {};
        }

        start = this.$moment(start).add(7, "day");
      }
      for (let i = 0; i < data.length; i++) {
        if (!this.represented_course.includes(data[i].nom)) {
          this.represented_course.push(data[i].nom);
        }
        let day = this.$moment(data[i].timestamp).endOf("week").format("DD/MM/YYYY");

        if (!this.per_week[day]) {
          this.per_week[day] = {};
        }

        if (!this.per_week[day][data[i].nom]) {
          this.per_week[day][data[i].nom] = 0;
        }
        this.per_week[day][data[i].nom]++;
      }
      this.build_series();
    },
    build_series() {

      this.series = [];
      for (let i = 0; i < this.represented_course.length; i++) {
        let data = [];
        for (let day in this.per_week) {

          this.categories.push(day);
          if (this.$moment(day, "DD/MM/YYYY").endOf("week").isAfter(this.$moment().endOf("week"))) {
            break;
          }
          if (this.per_week[day][this.represented_course[i]]) {
            data.push(this.per_week[day][this.represented_course[i]]);
          } else {
            data.push(0);
          }
        }

        this.series.push({
          name: this.represented_course[i],
          data: data,
        });

      }
      this.render_graph();
    },
    render_graph() {
      const chartId = "containerPerDay_" + this.id_module;
      Highcharts.chart(chartId, {
        chart: {
          height: 400,
          type: "column",
        },
        title: {
          text: undefined,
          align: "left",
        },
        plotOptions: {
          series: {
            marker: {
              enabled: false,
            },
          },
        },
        xAxis: {
          categories: this.categories,
        },
        yAxis: {
          min: 0,
          title: {
            text: "Inscriptions/semaine",
          },
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: "bold",
              color:
                // theme
                (Highcharts.defaultOptions.title.style && Highcharts.defaultOptions.title.style.color) || "gray",
              textOutline: "none",
            },
          },
        },
        legend: {
          align: "left",
          verticalAlign: "top",
          floating: false,
          backgroundColor: Highcharts.defaultOptions.legend.backgroundColor || "white",
          borderColor: "#CCC",
          borderWidth: 1,
          shadow: false,
        },
        tooltip: {
          headerFormat: "<b>{point.x}</b><br/>",
          pointFormat: "{series.name}: {point.y}",
        },
        series: this.series,
      });
    },
  },

};
</script>

<style lang="scss" scoped></style>